import { panMapToLatLng } from './panMapToLatLng';

export const zoomPolygonsIntoView = (google, map, polyArray) => {
  try {
    if (polyArray.length === 0) return;
    const filteredArray = polyArray.filter(arr=>arr.length > 2);
    let bounds = new google.maps.LatLngBounds();
    let path, paths;

    for(let polys = 0; polys < filteredArray.length; polys++) {
      paths = filteredArray[polys];

      for (let i = 0; i < paths.length; i++) {
        path = paths[i];
        bounds.extend(path);
      }
    }
    map.fitBounds(bounds);
    panMapToLatLng(map, bounds.getCenter());
  } catch(e) {
  }
}
